import * as React from "react";
const SvgFiRrExchangeAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M0 7a1 1 0 0 1 1-1h17V2.64a.793.793 0 0 1 1.35-.553l4.418 4.361a.774.774 0 0 1 0 1.1l-4.418 4.365a.792.792 0 0 1-1.35-.552v-3.36H1a1 1 0 0 1-1-1m23 9H6v-3.36a.792.792 0 0 0-1.35-.553L.232 16.448a.773.773 0 0 0 0 1.1l4.418 4.365A.792.792 0 0 0 6 21.361v-3.36h17a1 1 0 1 0 0-2"
    />
  </svg>
);
export default SvgFiRrExchangeAlt;
